import { useTranslation } from 'react-i18next';
import { noop } from 'lodash/fp';
import { doToggleWarehouseLoadDialog } from 'app/store/healthcheck';
import { selectExecutingQueryCount, selectQueryCount } from 'app/store/snowflakeQueries';
import { useDispatch, useSelector } from 'app/lib/hooks';
import { Button, ButtonEdge, ButtonVariant } from 'app/components/core/Button';
import * as styles from './WarehouseLoadDialogMenuButton.css';

export function WarehouseLoadDialogMenuButton({ onClick = noop }) {
    const { t } = useTranslation('components', { keyPrefix: 'WarehouseLoadDialog' });
    const dispatch = useDispatch();
    const total = useSelector(selectQueryCount) ?? 0;
    const executing = useSelector(selectExecutingQueryCount) ?? 0;

    function handleClick() {
        dispatch(doToggleWarehouseLoadDialog());
        onClick();
    }

    return (
        <Button
            className={styles.button}
            onClick={handleClick}
            icon="sql-small"
            edge={ButtonEdge.FLAT}
            variant={ButtonVariant.GHOST}
            fullWidth>
            {t('menu', { executing, total })}
        </Button>
    );
}
